module.exports = __webpack_public_path__ + "img/thumb_15.49fdc8b9.jpg";